import cx from 'classnames'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { IS_BRAND_PULSZ } from 'config/brands'
import ProductGameTile from 'containers/ProductGameTile'
import { format2RowSwimlane } from 'pageContainers/Home/utils/format2RowSwimlane'
import GameRowHeader from 'src/components/GameRowHeader'
import HorizontalScroll from 'src/containers/HorizontalScroll'
import { getActiveCurrencyIdSelector } from 'store/modules/currencies/selectors'
import { filterBingoGamesByMode } from 'utils/filterBingoGamesByMode'

import classes from '../SlotsRow/styles.module.scss'

import type { GameProductShort } from '@patrianna/shared-patrianna-types/store/GameModule'

type Props = {
  games: Array<GameProductShort>
  title: string
  url?: string
  lines?: number
  count?: number
  iconImg?: string
  code: string
  swimlaneIndex: number
  is3DTilesEnabled: boolean
  layout: string
}

export default function PreviouslyPlayedRow(props: Props) {
  const { games, lines, swimlaneIndex, is3DTilesEnabled, layout, ...headerProps } = props
  const activeCurrency = useSelector(getActiveCurrencyIdSelector)

  const baseGames = props.code === 'new' && lines === 2 ? format2RowSwimlane(games) : games
  const filteredGames = useMemo(
    () => (IS_BRAND_PULSZ ? baseGames : filterBingoGamesByMode(baseGames, activeCurrency)),
    [activeCurrency, games],
  )

  if (!filteredGames?.length) {
    return null
  }

  return (
    <>
      <GameRowHeader {...headerProps} with3DImage={is3DTilesEnabled} />
      <HorizontalScroll
        with3DImage={is3DTilesEnabled}
        data-test={`${props.title}-games-row`}
        classNameContainer={cx(
          classes.root,
          is3DTilesEnabled ? classes.slotsContainerRoot3D : classes.slotsContainerRoot,
        )}
        linesAmount={lines}
        styleContainer={{
          gridTemplateRows: `repeat(${lines}, auto)`,
        }}
      >
        {filteredGames.map((game, index) => (
          <ProductGameTile
            with3DImage={is3DTilesEnabled}
            game={game}
            category={props.title}
            gameIndex={index + 1}
            swimlaneIndex={swimlaneIndex}
            showFavorite
            layout={layout}
            key={`${props.title}-${game.code}`}
          />
        ))}
      </HorizontalScroll>
    </>
  )
}
